import { Args, BaseService } from './BaseService';
import { resources } from '../resources';
import { AxiosPromise } from 'axios';
import { CompanySettingsDto } from '../models/settings/CompanySettingsDto';
import { CompanyBusinessSettings } from '../models/settings/CompanyBusinessSettings';
import { WorkplaceHandoverSettingsDto } from '../models/settings/WorkplaceHandoverSettingsDto';
import { UpdateWorkplaceHandoverSettingsModel } from '../models/settings/UpdateWorkplaceHandoverSettingsModel';
import { WorkplaceHandoverSectionGroupDto } from '../models/settings/WorkplaceHandoverSectionGroupDto';
import { WorkplaceHandoverSectionGroupModel } from '../models/settings/WorkplaceHandoverSectionGroupModel';
import { CheckOptionsResponse } from '../models/settings/CheckOptionsResponse';

export class CompanySettingsService extends BaseService {
  public updateSettings(data: CompanySettingsDto, args?: Args): AxiosPromise<CompanySettingsDto> {
    return this.put<CompanySettingsDto>(resources.updateSettings, data, args);
  }

  public getSettings(args?: Args): AxiosPromise<CompanySettingsDto> {
    return this.get<CompanySettingsDto>(resources.getSettings, args);
  }

  public getBusinessSettings(args?: Args): AxiosPromise<CompanyBusinessSettings> {
    return this.get<CompanyBusinessSettings>(resources.getBusinessSettings, args);
  }

  public updateBusinessSettings(data: CompanyBusinessSettings, args?: Args): AxiosPromise<void> {
    return this.put<void>(resources.updateBusinessSettings, data, args);
  }

  public checkOptions(args?: Args): AxiosPromise<CheckOptionsResponse> {
    return this.get<CheckOptionsResponse>(resources.checkOptions, args);
  }

  public getWorkplaceHandoverSettings(args?: Args): AxiosPromise<WorkplaceHandoverSettingsDto> {
    return this.get<WorkplaceHandoverSettingsDto>(resources.getWorkplaceHandoverSettings, args);
  }

  public updateWorkplaceHandoverSettings(data: UpdateWorkplaceHandoverSettingsModel, args?: Args): AxiosPromise<void> {
    return this.put<void>(resources.updateWorkplaceHandoverSettings, data, args);
  }

  public getWorkplaceHandoverSections(args?: Args): AxiosPromise<WorkplaceHandoverSectionGroupDto[]> {
    return this.get<WorkplaceHandoverSectionGroupDto[]>(resources.getWorkplaceHandoverSections, args);
  }

  public addWorkplaceHandoverSection(args?: Args): AxiosPromise<WorkplaceHandoverSectionGroupDto> {
    return this.post<WorkplaceHandoverSectionGroupDto>(resources.addWorkplaceHandoverSection, {}, args);
  }

  public updateWorkplaceHandoverSections(data: WorkplaceHandoverSectionGroupModel[], args?: Args): AxiosPromise<void> {
    return this.put<void>(resources.updateWorkplaceHandoverSections, data, args);
  }
}
